import {User} from '../../users/user';
import * as fromAuth from '../actions';

export interface AuthState {
  user: User;
  loggedIn: Boolean;
  loggedOut: Boolean;
  error: string;
}

export const initialState = {
  user: null,
  loggedIn: false,
  loggedOut: true,
  error: null
};

export function reducer(state = initialState, action: fromAuth.UserActions): AuthState {
  switch (action.type) {
    case fromAuth.LOAD_USER: {
      return {
        ...state,
        loggedIn: false,
        loggedOut: false,
      };
    }
    case fromAuth.LOAD_USER_SUCCESS: {
      return {
        ...state,
        loggedIn: true,
        loggedOut: false,
        user: action.payload
      };
    }
    case fromAuth.LOGIN_USER_SUCCESS: {
      return {
        ...state,
        loggedIn: true,
        loggedOut: false,
        user: action.payload,
        error: null
      };
    }
    case fromAuth.LOGIN_USER: {
      return {
        ...state,
        loggedIn: false,
        loggedOut: true,
        error: null
      };
    }
    case fromAuth.LOGIN_USER_FAIL: {
      return {
        ...state,
        loggedIn: false,
        loggedOut: true,
        user: null,
        error: action.payload
      };
    }
    case fromAuth.NOT_AUTHENTICATED: {
      return {
        ...state,
        loggedIn: false,
        loggedOut: true,
        user: null,
        error: null
      };
    }
    case fromAuth.LOGOUT_USER: {
      return {
        ...state,
        loggedIn: false,
        loggedOut: true,
        user: null,
        error: null
      };
    }
  }
  return state;
}

export const getUserLoggedIn = (state: AuthState) => state.loggedIn;
export const getUserLoggedOut = (state: AuthState) => state.loggedOut;
export const getUser = (state: AuthState) => state.user;
export const getLoginErrorMessage = (state: AuthState) => state.error;



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/store/reducers/auth.reducer.ts